import { types as typesAuth } from '@/modules/auth/constant'
import routerName from '@/constants/routers'
import { SW_REDIRECT } from './../constants/storage'
import { getRouteRedirect } from '@/utils/redirect'

export default async function({ next, router , store, to}){
	/* check token from store */
    let token = store.getters[typesAuth.getters.GET_TOKEN]
    let data = store.getters[typesAuth.getters.GET_STORE]

    if(`${process.env.VUE_APP_MAITENANCE}` == 'true') {
        // next({ name: routerName.MAINTENANCE })
        next('/maintenance')
        return true
    }

	if( token ){
        /* get user from store */
		try {
            if ( !data ) {
                let res = await store.dispatch(typesAuth.actions.GET_STORE)
                if ( res.data.status ) {
                    data = res.data.data
                }
            }
			if( data ){
                // if(`${process.env.VUE_APP_MAITENANCE}` == 'true' && !data.test) {
                //     next({ name: routerName.MAINTENANCE })
                //     return true
                // }
                if (data.reject_app) {
                    window.location.href = 'https://' + data.shopify_domain + '/admin/account/please_upgrade'
                    return true
                }

                if(!data.app_plan || data.re_install || (data.app_plan && data.app_plan != 'free' && !data.billing_id)){
                    if(to.name == routerName.CHOOSE_PLAN){
                        return true
                    }
                    next({ name: routerName.CHOOSE_PLAN })
                    return false
                }

                if (data.onboarding_required) {
                    if(to.name == routerName.ONBOARD || to.name == routerName.ONBOARD_SET_UP){
                        return true
                    }
                    next({ name: routerName.ONBOARD })
                    return false
                }

                if(data.update_required && to.name != routerName.UPDATE_APP){
                    next({ name: routerName.UPDATE_APP })
                    return false
                }

                if((!data.onboarding_required && (to.name == routerName.ONBOARD || to.name == routerName.ONBOARD_SET_UP)) || (to.name == routerName.CHOOSE_PLAN && !data.re_install && ((data.app_plan && data.app_plan == 'free') || (data.app_plan && data.app_plan != 'free' && data.billing_id)))){
                    next({ name: routerName.DASHBOARD })
                    return false
                }

                if(to.query.hasOwnProperty("redirect")){
                    let routeRedirect = getRouteRedirect(to.query.redirect) 
                    next({ name: routeRedirect })
                    return false
                }

                if (sessionStorage.getItem(SW_REDIRECT)) {
                    let routeRedirect = getRouteRedirect(sessionStorage.getItem(SW_REDIRECT)) 
                    next({ name: routeRedirect })
                    sessionStorage.removeItem(SW_REDIRECT)
                    return false
                }
                return true
            }
            return false
		} catch (err) {
            next({ name: routerName.INSTALL_APP })
			return false
		}
	}
	/* finally if return login page for all false conditions */
	next({ name: routerName.INSTALL_APP })
	return false
}
